import type { RefdataDatasetId } from '../../types/refdata';
/** Private CLI acceptance cache isolation. Browser and ordinary workers keep their normal keys. */
let acceptance: { digest: string; providerIds: ReadonlySet<string> } | null = null;
export function installAcceptanceCacheIdentity(digest: string, providerIds: readonly string[]): void {
  if (typeof window !== 'undefined' || !/^[a-f0-9]{64}$/.test(digest)) throw new Error('Invalid private acceptance cache identity');
  if (acceptance && acceptance.digest !== digest) throw new Error('Cannot mix reference-data acceptance snapshots in one worker');
  acceptance = { digest, providerIds: new Set(providerIds) };
}
export function acceptanceCacheSuffix(providerId: string): string {
  return typeof window === 'undefined' && acceptance?.providerIds.has(providerId) ? `:acceptance-${acceptance.digest}` : '';
}

/** Dataset IDs and provider IDs differ; isolate the providers that read each private source. */
export function installAcceptanceDatasetCacheIdentity(digest: string, datasetIds: readonly RefdataDatasetId[]): void {
  installAcceptanceCacheIdentity(digest, [...new Set(datasetIds.flatMap(id => id.startsWith('fema-') ? ['fema-flood']
    : id === 'usgs-3dep' ? ['site-profile', 'usgs-3dep'] : id === 'wri-aqueduct' ? ['wri-aqueduct']
    : id === 'padus' ? ['padus-protected'] : ['usfws-env']))]);
}
